import { gql } from '@apollo/client';

export const createProposalPerson = gql`
  mutation createProposalPerson(
    $mainBusinessPartnerID: String!
    $personInput: CreateProposalPersonInput!
  ) {
    production {
      createProposalPerson(
        mainBusinessPartnerID: $mainBusinessPartnerID
        personInput: $personInput
      )
    }
  }
`;

export const calculateBasicRate = gql`
  mutation calculateBasicRate($currency: String!) {
    core {
      CalculateBasicRate(currencyID: $currency)
    }
  }
`;

export const saveDraft = gql`
  mutation saveDraft($id: String!, $input: SaveDraftGenericInput!) {
    production {
      saveDraftGeneric(id: $id, input: $input)
    }
  }
`;

export const calculateAndSave = gql`
  mutation calculateAndSave(
    $id: String!
    $input: CalculateAndSaveGenericInput!
  ) {
    production {
      calculateAndSaveGeneric(id: $id, input: $input)
    }
  }
`;

export const removePolicyPlanCover = gql`
  mutation removePolicyPlanCover($policyPlanCoverId: String!) {
    production {
      removePolicyPlanCover(policyPlanCoverId: $policyPlanCoverId)
    }
  }
`;

export const uploadMedicalInsuredList = gql`
  mutation uploadMedicalInsuredList(
    $document: Upload!
    $documentName: String!
    $proposalID: String!
  ) {
    production {
      uploadMedicalInsuredList(
        document: $document
        documentName: $documentName
        proposalID: $proposalID
      ) {
        column
        description
        row
        type
      }
    }
  }
`;
